import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import {
  fromCognitoIdentityPool,
} from '@aws-sdk/credential-provider-cognito-identity';
import { getAuth } from '@/utils/authManager';
import awsmobile from '@/aws-exports';

const configsCache = {};

function generateConfig(params = {}) {
  let config = {};
  config = {
    region: awsmobile.aws_project_region,
    credentials: fromCognitoIdentityPool({
      identityPoolId: awsmobile.aws_cognito_identity_pool_id,
      client: new CognitoIdentityClient({ region: awsmobile.aws_cognito_region }),
      logins: {
        [`cognito-idp.${awsmobile.aws_cognito_region}.amazonaws.com/${awsmobile.aws_user_pools_id}`]: getAuth() ? getAuth().id_token : null,
      },
    }),
  };
  // Merge in any additional params
  // in case same keys are used params will override config
  config = { ...config, ...params };

  return config;
}

export default function getConfig(params = {}) {
  const key = JSON.stringify(params);

  // If the configuration for the given key is not in the cache
  // generate it and store it in the cache
  if (!configsCache[key]) {
    configsCache[key] = generateConfig(params);
  }

  return configsCache[key];
}
